import { ColorScaleConfig } from '@/utils/colorScale'
import { Pattern } from './bars'
import { Limits } from './limits'
import { ChartComponent } from '..'

export type AreaHoverHighlight = {
  label: string
  color: string
  path: [number, number][]
  value: [number, number]
  pattern?: Pattern
  colorScale?: ColorScaleConfig
  visible?: boolean
}

export const createAreaHightlight = (
  { color, label, path, value, pattern, colorScale, visible }: AreaHoverHighlight,
  limits: Limits
): ChartComponent<'highlight-area'>[] => [
  {
    type: 'highlight-area',
    xLimits: limits.x,
    yLimits: limits.y,
    label: label,
    color: color,
    colorScale,
    pattern,
    value,
    visible,
    path
  }
]

export const createAreaHightlights = (
  areas: AreaHoverHighlight[],
  limits: Limits
): ChartComponent<'highlight-area'>[] => {
  return areas.flatMap((area) => createAreaHightlight(area, limits))
}
